import * as TYPES from './constants';
import {API} from 'config/employer.config';
import {JWT_HEADER, JSON_HEADER} from 'config/srm.config';
import {
  requestEnrolledList,
  receiveEnrolledList,
  handleEnrolledListError,
} from './actions';

const initialState = {
  data: null,
  error: false,
  request: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case TYPES.ENROLLED_LIST_REQUEST:
      return {
        ...state,
        request: true,
      };
    case TYPES.ENROLLED_LIST_RECEIVE:
      return {
        ...state,
        request: false,
        data: action.payload,
      };
    case TYPES.ENROLLED_LIST_ERROR:
      return {
        ...state,
        error: true,
        request: false,
      };
    case TYPES.CLEAR_ENROLLED_LIST:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export const fetchEnrolledList = (id, params) => (dispatch, getState) => {
  const {
    auth: {
      access: {token},
    },
  } = getState();
  const config = {
    mode: 'cors',
    method: 'GET',
    cache: 'default',
    headers: Object.assign({}, JWT_HEADER(token), JSON_HEADER),
  };
  dispatch(requestEnrolledList());
  const {page = 1, sort = 'name_asc', pageSize = 10, filters = []} =
    params || {};
  let URI = `${
    API.administration.enrolled_student_list
  }?path_uuid=${id}&page=${page}&page_size=${pageSize}&sort=${sort}`;
  if (filters && filters.length > 0) {
    filters.forEach(filter => {
      URI += `&${filter.key}=${filter.value}`;
    });
  }

  try {
    return fetch(URI, config)
      .then(response => response.json())
      .then(json => {
        dispatch(receiveEnrolledList(json));
      })
      .catch(err => {
        console.log(err);
        dispatch(handleEnrolledListError(err));
      });
  } catch (err) {
    console.log(err);
    dispatch(handleEnrolledListError(err));
  }
};
